module.exports = __webpack_public_path__ + "static/file-object.d12a752c.svg";